import CustomizedSnackbar from "components/CustomizedSnackbar";
import useNotifier from "hooks/useNotifier";

function GlobalNotification() {
  const { isOpen, notification, hideNotification } = useNotifier();

  return (
    <CustomizedSnackbar
      message={notification.message}
      onClose={hideNotification}
      open={isOpen}
      severity={notification.severity}
    />
  );
}

export default GlobalNotification;
